import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Discount/discount.container"
    ).then((module) => ({
        default: module.DiscountContainer
    }))
);
